// Used via Metrics.baseMargin
const metrics = {
  maxWidth: 1316,
  marginHorizontal: 10,
  marginVertical: 10,
  section: 25,
  baseMargin: 16,
  doubleBaseMargin: 32,
  smallMargin: 8,
  doubleSection: 50,
};

export default metrics;
